import { DeviceCar } from '@/assets/icons/DeviceCar';
import { DeviceMultiple } from '@/assets/icons/DeviceMultiple';
import { DynamicTable, type DynamicTableRow } from '@/ui-components/molecules/DynamicTable/DynamicTable';
import styles from './broadcastGrid.module.scss';

const COLUMNS = [
    { key: 'car', label: 'In the car', Icon: DeviceCar },
    { key: 'app', label: 'On your device', Icon: DeviceMultiple },
];

export interface BroadcastGridProps {
    rows: DynamicTableRow[];
}

export function BroadcastGrid({ rows }: BroadcastGridProps) {
    const columnLabels = COLUMNS.map(({ key, label, Icon }) => (
        <span key={key} role="img" aria-label={label}>
            <Icon className={styles.icon} />
        </span>
    ));

    return (
        <DynamicTable cornerLabelAriaText="Broadcast" columnLabels={columnLabels} rows={rows} className={styles.grid} />
    );
}
